import React, { FC, useCallback } from 'react';

import { useFormContext } from 'react-hook-form';

import { Checkbox } from '@appcharge/shared-ui';

const ShowAvailabilityCheckbox: FC = (): React.ReactElement => {
  const form = useFormContext();
  const hideAvailability = form.watch('hideAvailability');

  const handleChange = useCallback(
    (checked: boolean): void => {
      form.setValue('hideAvailability', !checked, { shouldDirty: true });
    },
    [form]
  );

  return (
    <Checkbox
      checked={!hideAvailability}
      onCheckedChange={handleChange}
      label="Show Availability"
    />
  );
};

export { ShowAvailabilityCheckbox };
